var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.items.length)?_c('b-row',{staticClass:"j-center m-t-25"},[_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('btn-loader',{staticClass:"m-b-30",attrs:{"disabled":_vm.loader,"icon":"check","text":_vm.text_btn,"loader":_vm.loader,"size":"lg","dusk":"btn_vender"},on:{"clicked":_vm.saveSale}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }